import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

import axios from 'axios';
import VueAxios from 'vue-axios';

const noticias = {
  state: {},
  getters: {},
  mutations: {
    null() {

    }
  },
  actions: {

    requestNoticia: ({
      commit
    }, data) => {

      console.log(data);

      return new Promise((resolve) => {
        axios.post(`/api/entry`, data).then(response => {
          resolve(response.data);
          commit('null');
        });
      });
    },
    requestNoticiaSlug: ({
      commit
    }, id) => {
      return new Promise((resolve) => {

        axios.get(`/api/entry${(id) ? '/'+id : ''}`).then(response => {

          resolve(response.data);
          commit('null');
        });
      });
    }

  },
  modules: {}
}

export default noticias;



// WEBPACK FOOTER //
// ./src/store/noticias.js